/**
 * Styled Components - Created by eduardo on 20/12/18.
 */
import styled from 'styled-components'
import AntIcon from 'antd/lib/icon'
import Tabs, { TabsProps } from 'antd/lib/tabs'
import React from 'react'

interface ColorSliderProps {
  totalColors: number
  currentSelected: number
}

interface OvalProps {
  secondary?: boolean
  currentColor?: string
  totalPadding?: number
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 11;
  flex-direction: column;
  & .ant-tabs-tab {
    margin: 0;
  }
`

export const LabelShuffle = styled.p`
  display: flex;
  align-items: center;
  background: white;
  justify-content: space-between;
  padding: 5px 6px;
  color: #5f6062;
  font-family: 'Avenir Next';
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.13px;
  margin: 0;
  position: absolute;
  left: 224px;
  top: 5px;
  z-index: 2;
  border-radius: 30px;
  box-shadow: 
    0 0.025em 0.4em -0.02em hsl(190.96deg 100% 65% / 25%), 
    0 0.05em 0 0 hsl(58.24deg 100% 50%) inset, 
    0 -0.05em 0 0 hsl(213.61deg 100% 50%) inset, 
    0 0.025em 0.4em -0.02em hsl(0 0% 100% / 0.25) inset, 
    0 0.025em 0.4em -0.02em hsl(306.21deg 100% 50% / 25%) inset;
  &:hover {
    box-shadow: 0px 1px 3px -1px gray;
    transform: scale(1.03);
  }
`

export const Label = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  color: #5f6062;
  font-family: 'Avenir Next';
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.13px;
  margin: 0;
`

export const HintIcon = styled.img`
  cursor: pointer;
  max-width: 16px;
  width: 100%;
  margin-left: 8px;
  margin-bottom: 2px;
`

export const ShuffleButton = styled.div`
  display: flex;
  align-items: center;
`

export const Icon = styled.img`
  width: 13px;
  opacity: 50%;
  margin-left: 5px;
`

export const ColorSlider = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &:after {
    height: 2px;
    width: calc(
      100% / ${({ totalColors }: ColorSliderProps) => totalColors} - 10px
    );
    content: '';
    position: absolute;
    left: calc(
      100% / ${({ totalColors }: ColorSliderProps) => totalColors} *
        ${({ currentSelected }: ColorSliderProps) => currentSelected} + (5px)
    );
    bottom: -7px;
    transition: all 0.3s ease;
  }
`

export const ColorOval = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid
    ${({ currentColor }: OvalProps) =>
    currentColor && currentColor.toLowerCase() !== '#ffffff'
      ? currentColor
      : '#bebebe'};
  background-color: ${({ currentColor }: OvalProps) => currentColor || '#fff'};
`

export const TabArea = styled.div`
  margin-left: 5px;
`

export const TabContainer = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  width: 100%;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
  &:last-child {
    border-bottom: none;
  }
  margin-top: 4px;
`

export const TabTitle = styled.div`
  font-weight: bold;
  font-family: Avenir;
  img {
    max-width: 16px;
    margin-top: -2px;
    margin-right: 6px;
    margin-left: -4px;
  }
`

export const Divider = styled.div`
  height: 1px;
  background-color: #dcdcdc;
`

export const StyledTabs = styled(Tabs as React.ComponentClass<TabsProps>)`
  & .ant-tabs-nav-scroll {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
  & .ant-tabs-tab-arrow-show  {
    display: none;
  }
  & .ant-tabs-nav-container {
    padding: 0;
  }
  ${({ secondary }: OvalProps) => secondary ? `
    padding: 8px 10px;
  ` : ''}
`

export const TabsPalettes = styled(Tabs)`
  transition: all .25s;
  padding-bottom: 7px;
  &.tabsMain > .ant-tabs-bar > .ant-tabs-nav-container {
    height: 36px;
  }
  &.tabsMain > .ant-tabs-bar > .ant-tabs-nav-container > .ant-tabs-nav-wrap 
  > .ant-tabs-nav-scroll > .ant-tabs-nav > div > .ant-tabs-tab {
    margin: 0;
    border: 1px solid #d5d5d5;
    border-bottom: 1px solid #e2e2e2;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 2px 0px 4px -1px #e1e1e1;
    background: #fcfcfc;
    margin-right: 4px;
    padding: 0px 14px;
    line-height: 34px;
    &.ant-tabs-tab-active {
      border: 1px solid #a2a2a2;
      border-bottom: 1px solid white;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background: white;
    }
  }
  .ant-tabs-card-content {
    background: white;
    transition: all .25s;
    height: ${({ secondary }: OvalProps) => secondary ? 'auto' : '0'};
  }
  .ant-tabs-bar {
    margin-bottom: 0px;
  }
`

export const CollapseButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  color: white;
  background: #3b3b3b;
  width: 42px;
  height: 36px;
  border-radius: 7px 7px 0 0;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
`

export const DownArrow = styled(AntIcon)``

export const TrendContainer = styled.div`
  transition: all .25s;
  max-height: 44vh;
  background: white;
  padding-top: 20px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .3);
  }
`

export const ThreeDButton = styled.img`
  max-width: 46px;
  border-radius: 10px;
  padding: 6px;
  margin-top: -12px;
  box-shadow: 0px 2px 4px -1px #c3c3c3;
  border: 1px solid #f3f3f3;
  z-index: 2;
  right: 10px;
  position: absolute;
  top: -52px;
  transition: all .5s;
  -webkit-touch-callout: none !important;
  user-select: none !important;
  ${({ secondary }: OvalProps) => secondary ? `
    background: #f0f0f0;
    box-shadow: 0px 3px 8px -2px black inset;
    border-color: transparent;
  ` : ''}
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/MobileSelectColors/styledComponents.tsx